<template>
	<div class="wrapper">
		<!-- <side-bar v-if="$store.state.authentication.account_type == 'sa'"> -->
		<side-bar>
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>Dashboard</p>
			</sidebar-link>
			<sidebar-link to="/sensors">
				<md-icon>memory</md-icon>
				<p>Sensors</p>
			</sidebar-link>
			<sidebar-link to="/maps">
				<md-icon>map</md-icon>
				<p>Maps</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>Settings</p>
			</sidebar-link>
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>Administrators</p>
			</sidebar-link>
		</side-bar>

		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue